<template>
    <div style="padding: 50px 18px 18px; ">
        <div class="row mb-2">
            <div class="col-12">
                <a href="javascript:void(0)" @click="close" class="float-left">&lt;&lt; Back to messages</a>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label><strong>To</strong>&nbsp;<small v-if="emailAddresses && showCustom == true"><a href="javascript:void(0);" @click="showAddressList">[Show address list]</a></small></label>
                    <div v-if="emailAddresses  && showCustom == false">
                        <select class="form-control form-control-sm mb-2" v-model="selected">
                            <option :value="null">-- SELECT --</option>
                            <option v-for="(a,idx) in emailAddresses" :key="'emailAddress_' + idx" :value="a">
                                {{a.emailAddress}}{{a.type != 'Sender' ?  ' - ' + a.type : ''}}
                            </option>
                            <optgroup label="Custom">
                                <option :value="'CUSTOM'">Use address not in list</option>
                            </optgroup>
                        </select>
                    </div>
                    <input v-else type="text" v-model="to" class="form-control form-control-sm" />
                </div>
                <div class="form-group">
                    <label><strong>Subject</strong></label>

                    <input type="text" v-model="subject" class="form-control form-control-sm" />
                </div>
                <div class="form-group">                    
                    <wysiwyg v-if="!previewMode" v-model="body" />
                    <iframe v-else
                            v-on:load="previewLoaded"
                            ref="preview" 
                            style="width: 100%; border: 1px solid #ced4da; border-radius: 0.25rem;" 
                            :style="'height: ' + previewHeight + 'px'"
                            class="embed-responsive-item"
                            :src="getBlobURL(preview, 'text/html')">
                    </iframe>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="float-right">
                    <button v-if="!previewMode" type="button" class="btn btn-primary mr-2" @click="previewEmailClick()">Preview</button>
                    <button type="button" class="btn btn-primary mr-2" @click="sendEmailClick()">Send</button>
                    <button v-if="previewMode" type="button" class="btn btn-primary mr-2" @click="closePreview()">Edit</button>
                    <button type="button" class="btn btn-primary" @click="close()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import { SEND_EMAIL, SEND_EMAIL_COMPLETE, PREVIEW_EMAIL, PREVIEW_EMAIL_COMPLETE } from '@/messageEvents.js';

    import { NEW_MESSAGE, REPLY_MESSAGE, FORWARD_MESSAGE } from './composeActionTypes.js';

    export default {
        name: "message-compose",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            message: {
                type: Object,
                required: false
            },
            emailAddresses: {
                type: Array,
                required: false,
                default: () => []
            },
            messageSubject: {
                type: String,
                required: false,
                default: ''
            },
            actionType: {
                type: String,
                required: false,
                default: NEW_MESSAGE
            }
        },
        data: () => {
            return {
                selected: null,
                showCustom: false,

                to: '',
                subject: '',
                body: '',
                preview: null,
                previewDocHeight: 0
            };
        },
        watch: {
            selected: function (val) {
                if (val == 'CUSTOM') {
                    this.to = ''
                    this.showCustom = true
                } else {
                    this.to = val.emailAddress
                }
            }
        },
        computed: {
            previewMode() {
                return this.preview != null
            },
            previewHeight() {
                return this.previewDocHeight
            }
        },
        methods: {
            messageInclude() {
                if (this.message) {
                    let from = `<strong>From:</strong> ${this.message.from}<br />`
                    let sent = `<strong>Sent:</strong> ${this.message.documentDateCreatedUK}<br />`
                    let to = `<strong>To:</strong> ${this.message.to}<br />`
                    let subject = `<strong>Subject:</strong> ${this.message.subject}<br />`

                    return `<br /><br /><br /><hr />${from}${sent}${to}${subject}${this.message.html}`
                } else {
                    return ''
                }
            },
            showAddressList() {
                this.selected = null
                this.showCustom = false
            },
            close() {
                this.$emit("closePanel");
            },
            getMessageHashCode() {
                let { to, subject } = this
                let base = to + subject + new Date().getTime()
                return base.hashCode()
            },
            sendEmailClick() {
                let { to, subject, body } = this
                let eventId = this.getMessageHashCode()

                EventBus.$emit(SEND_EMAIL + '_' + this.eventTarget, { eventId, to, subject, message: body })
                EventBus.$once(SEND_EMAIL_COMPLETE + '_' + eventId, (payload) => {
                    //console.log(SEND_EMAIL_COMPLETE + '_' + eventId + ': ', payload)
                    if (payload === true) {
                        this.$emit('closePanel')
                    }
                    
                });

                
            },
            previewEmailClick() {
                let { to, subject, body } = this
                let eventId = this.getMessageHashCode()

                EventBus.$emit(PREVIEW_EMAIL + '_' + this.eventTarget, { eventId, to, subject, message: body })
                EventBus.$once(PREVIEW_EMAIL_COMPLETE + '_' + eventId, (payload) => {
                    //console.log(PREVIEW_EMAIL_COMPLETE + '_' + eventId + ': ', payload)
                    this.preview = payload.messageHtml

                });


            },
            getBlobURL(code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            },
            previewLoaded(payload) {
                console.log('preview - onload')
                console.log(this.$refs["preview"].contentWindow.document.documentElement.scrollHeight)
                this.previewDocHeight = this.$refs["preview"].contentWindow.document.documentElement.scrollHeight
            },
            closePreview() {
                this.preview = null
            }
        },
        mounted() {

            switch (this.actionType) {
                case NEW_MESSAGE:
                    this.subject = this.messageSubject
                    break;
                case REPLY_MESSAGE:
                    this.showCustom = true
                    if (this.message) {
                        this.to = this.message.from
                        this.subject = 'RE: ' + this.message.subject
                        this.body = this.messageInclude()
                    }
                    break;
                case FORWARD_MESSAGE:
                    if (this.message) {
                        this.subject = 'FW: ' + this.message.subject
                        this.body = this.messageInclude()
                    }
                    break;
            }
        }
    };
</script>
<style scoped>
    
</style>
